import { apiFetch, qs } from '../lib/api';

export type AuditAction = 'create' | 'update' | 'delete' | 'import' | 'restore';

export interface AuditRow {
  id: number;
  entity_table: string;
  entity_id: number;
  action: AuditAction;
  diff: Record<string, unknown>;
  actor: string;
  request_id: string | null;
  created_at: string;
}

export interface AuditListParams {
  entity_table?: string;
  entity_id?: number;
  actor?: string;
  action?: AuditAction;
  limit?: number;
  offset?: number;
}

export interface AuditListResponse {
  data: AuditRow[];
  meta: { total: number; limit: number; offset: number };
}

export function listAudit(params: AuditListParams = {}): Promise<AuditListResponse> {
  return apiFetch(`/admin/audit${qs(params as Record<string, unknown>)}`);
}
